var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconParachute = function SvgIconParachute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.929 4.179A10 10 0 0 1 12 1.25h.002a10 10 0 0 1 9.996 10.068 1 1 0 0 1-.383.72l-.017.014L13 18.5V20h.5a1 1 0 0 1 0 2h-3a1 1 0 1 1 0-2h.5v-1.5l-8.598-6.448-.017-.013A1 1 0 0 1 2 11.238a10 10 0 0 1 2.929-7.06m4.314-.439a8 8 0 0 0-5.18 6.51h3.214c.162-2.98 1.038-5.09 1.966-6.51M6 12.25 11 16v-3.75zm3.28-2c.161-2.616.94-4.37 1.677-5.477.38-.57.755-.976 1.043-1.246.288.27.663.677 1.043 1.246.738 1.107 1.516 2.86 1.677 5.477zm3.72 2V16l5-3.75zm3.723-2c-.162-2.98-1.038-5.09-1.966-6.51a8 8 0 0 1 5.18 6.51z",
    clipRule: "evenodd"
  })));
};
export default SvgIconParachute;